export default String.raw`
.product-presentation{
  margin: 30px 32px;
    &__top-section{
        display: grid;
        grid-template-columns: 55% auto;
        grid-template-rows: auto auto;
        gap: 20px;
        &.table-view{
            display: flex;
            flex-direction: column;
            .gallery-container{
                order: 2;
            }
            .product-name-container{
                order: 1;
            }
            .main-content-container{
                order: 3;
            }
        }
        .gallery-container{
            grid-column: 1 / 2;
            grid-row: 2 / 3;
        }
        .product-name-container{
            grid-column: 1 / 3;
            grid-row: 1 / 2;
        }
        .main-content-container{
            grid-column: 2 / 3;
            grid-row: 2 / 3;
            &.simple-product .main-content-container__attributes{
            display: none;
            }
            .buttons-container {
              display: flex;
              justify-content: space-between;
              flex-direction: column;
            }
        }
    }
}

.product-label {
  margin: 0;
}

@media screen and (max-width: 1350px) {
  .product-label {
    &__details {
      .name-container {
        .name {
          max-width: 700px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 1050px) {
  .product-label {
    &__details {
      .name-container {
        .name {
          max-width: 600px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 930px) {
  .product-label {
    &__details {
      .name-container {
        .name {
          max-width: 500px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 850px) {
  .product-label {
    &__details {
      .name-container {
        .name {
          max-width: 400px !important;
        }
      }
    }
  }
}

.reviews-container {
  &__content {
    margin: 0;
    
    .review {
      grid-template-columns: 40% 1fr;
    }

    .no-reviews {
      flex-direction: row;
      align-items: center;
      gap: 12px;
    }
  }

  &__header {
    justify-content: space-between;
    flex-direction: column;

    .review-overall {
      flex-direction: row;

      .stars {
        gap: 8px;
      }
    }

    .reviews-summary {
      flex: auto;
    }
  }
}

.sets-container {
  .sets-details {
    display: flex;
    width: 100%;
    flex-direction: column;
    gap: 0;

    .sets {
      margin: 16px 0;

      &__price-details {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        
        .primary-action-button {
          width: fit-content;
        }
      }
    }
  }
}

.related-container {
  .related-details {
    .related {
      margin: 16px 0;

      &__wrapper {
        width: calc(100% / 3);
      }
    }
  }
}

.no-reviews-js {
  align-items: center;
}

.add-review {
  max-width: none;
}

.product-navigation {
  .product-label {
    margin: 0;
  }
}

.downloads {
  .attachements {
    display: block;
  }
}
`